import { ConfigurationContext } from 'components/provider/OrginazationContext';
import { FC, Fragment, useContext } from 'react';
import { ActionType } from 'utils/action.type.enum';

interface IPrimaryButton {
  title: string;
  type: 'button' | 'submit';
  isOutline?: boolean;
  iconName?: string;
  onClick?: () => void;
  className?: string;
  isLoading?: boolean;
  isDanger?: boolean;
  large?: string;
  small?: string;
  margin?: string;
  disabled?: boolean;
    module_code?: string;
  actionType?:ActionType
}

const PrimaryButton: FC<IPrimaryButton> = ({
  title,
  type,
  isOutline,
  iconName,
  onClick,
  className,
  small,
  disabled = false,
  margin,
  isLoading = false,
  isDanger = false,
    actionType,
  module_code,
}) => {
    const { permission } = useContext(ConfigurationContext);
      const modulePermission = permission?.find(
    (item: any) => item.module_code === module_code
  );

  const hasPermission =(modulePermission&&actionType &&module_code)?  modulePermission
    ? modulePermission[actionType]
    : false:true
  return (
    <Fragment>

    {hasPermission?<button
      type={type}
      className={`btn btn-${isOutline ? 'outline-' : ''}${
        isDanger ? 'danger ' : 'primary '
      } add-btn 
      ${small} ${margin && margin}`}
      id="create-btn"
      onClick={onClick}
      disabled={disabled}>
      <div className="d-flex align-items-center justify-content-center">
        {iconName && <i className={`${iconName} align-bottom me-1`} />}
        {title}
        {isLoading && (
          <div className="spinner-border spinner-border-sm text-light ms-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )}
      </div>
    </button>:''}
        </Fragment>
  );
};

export default PrimaryButton;
